package one.healthium.log_period.models

import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.until
import one.healthium.base.utils.InstantToLocalDate
import one.healthium.domain.user.models.PeriodLogModel
import one.healthium.log_period.domain.PeriodPhase
import kotlin.time.Clock

fun PeriodLogModel.getPeriodDuration(): Int {
    if (periods.isEmpty()) return 28
    val sortedDates: List<LocalDate> = periods
        .map { InstantToLocalDate(it) }
        .sorted()
    val chains = mutableListOf<Pair<LocalDate, LocalDate>>()
    var chainStart = sortedDates.first()
    for (i in 1 until sortedDates.size) {
        val gap = sortedDates[i - 1].until(sortedDates[i], DateTimeUnit.DAY)
        if (gap > 7) {
            val chainEnd = sortedDates[i].minus(1, DateTimeUnit.DAY)
            chains.add(chainStart to chainEnd)
            chainStart = sortedDates[i]
        }
    }
    if (chains.isEmpty()) return 28

    val durations = chains.map { (start, end) ->
        start.until(end, DateTimeUnit.DAY) + 1
    }

    return if (chains.size == 1) {
        ((durations.first() + 28) / 2).toInt()
    } else {
        (durations.sum() / durations.size).toInt()
    }
}

fun PeriodLogModel.getPeriodPhase(): PeriodPhase {

    if (periods.isEmpty()) return PeriodPhase.UNDEFINED else return PeriodPhase.NORMAL_CYCLE
}

fun PeriodLogModel.getPeriodDay(): Int? {
    if (periods.isEmpty()) return null

    val sorted = periods
        .map { InstantToLocalDate(it) }
        .sorted()

    val currentDate = Clock.System.now()
        .toLocalDateTime(TimeZone.currentSystemDefault())
        .date

    var chainStartIndex = sorted.lastIndex
    for (i in sorted.lastIndex downTo 1) {
        val gap = sorted[i - 1].until(sorted[i], DateTimeUnit.DAY)
        if (gap <= 7) {
            chainStartIndex = i - 1
        } else {
            break
        }
    }
    val chainStart = sorted[chainStartIndex]
    return chainStart.until(currentDate, DateTimeUnit.DAY).toInt() + 1
}